import React from "react";
import CanvaVideo from "./Sections/CanvaVideo";
import Tutorial from "./Sections/Tutorial";
import TutorialFlow from "./Sections/TutorialFlow";

const TutorialPage = () => {
  return (
    <>
      {/* <Tutorial />
      <CanvaVideo embedId="DAEexPY4QBE" /> */}
      <TutorialFlow />
    </>
  );
};

export default TutorialPage;
